import { motion, useScroll, useTransform } from "motion/react";
import { useRef } from "react";
import { ListItemComponent } from "./ListItem";

export function ContentCard({ items, startIndex = 0 }) {
  const cardRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: cardRef,
    offset: ["start end", "end start"],
  });

  const y = useTransform(scrollYProgress, [0, 1], [50, -50]);
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [0.95, 1, 0.98]);

  return (
    <motion.div
      ref={cardRef}
      className="relative rounded-xl md:rounded-2xl p-5 sm:p-6 md:p-8 lg:p-10 backdrop-blur-sm will-change-transform"
      style={{
        y,
        scale,
        backgroundImage:
          "linear-gradient(130deg, rgba(255, 255, 255, 0.05) 0%, rgba(0, 0, 0, 0) 100%)",
      }}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{
        duration: 0.8,
        ease: [0.25, 0.46, 0.45, 0.94],
      }}
      role="list"
      aria-label="Table of contents section"
    >
      <div
        className="absolute inset-0 pointer-events-none rounded-xl md:rounded-2xl item-border border-[rgba(255,255,255,0.1)]"
        aria-hidden="true"
      />
      <div className="flex flex-col gap-3 sm:gap-4 md:gap-5">
        {items.map((item, index) => (
          <ListItemComponent
            key={`${startIndex + index}-${item.text}`}
            text={item.text}
            level={item.level}
            index={index}
          />
        ))}
      </div>
    </motion.div>
  );
}
